import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import BrandLogo from '../images/logo.svg';
import { resolveApiUrl } from '../api/adminApi';

export const Brand = ({ compact = false }) => (
  <Link className={`brand ${compact ? 'brand--compact' : ''}`} to="/" aria-label="DigitalWerks identity home">
    <img src={BrandLogo} alt="DigitalWerks" />
    {!compact && <span>Identity administration</span>}
  </Link>
);

const PortalShell = () => {
  const { user, signOut } = useAuth();
  const location = useLocation();
  const userSection = location.pathname.startsWith('/admin/users');

  return (
    <div className="portal-shell">
      <a className="skip-link" href="#main-content">Skip to main content</a>
      <header className="portal-header">
        <Brand />
        <nav aria-label="Administration">
          <NavLink className={({ isActive }) => isActive || userSection ? 'active' : ''} to="/admin/users">Users</NavLink>
        </nav>
        <div className="account-summary">
          <span className="avatar avatar--small" aria-hidden="true">{user?.avatar?.url ? <img src={resolveApiUrl(user.avatar.url)} alt="" /> : (user?.name || 'A').slice(0, 1).toUpperCase()}</span>
          <span className="account-copy"><strong>{user?.name || 'Administrator'}</strong><small>Level {user?.admin?.access ?? user?.accessLevel ?? 10}</small></span>
          <button className="button button--quiet" type="button" onClick={signOut}>Sign out</button>
        </div>
      </header>
      <main id="main-content" className="portal-main" tabIndex="-1"><Outlet /></main>
    </div>
  );
};

export default PortalShell;
